import { useEffect, useState } from "react";
import { ThemeContext } from "./contexts/theme-context";
import Layout from "./components/Layout";

function App() {
  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    setTheme(localStorage.getItem("theme") ?? "dark");
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      <div className={`theme-${theme}`}>
        <Layout />
      </div>
    </ThemeContext.Provider>
  );
}

export default App;
